import './Title.styles.scss';

import PropTypes from 'prop-types';

import prepareClassNames from '../../utils/prepareClassNames';

/* Size prop can accept following values: 'authorization' 'medium' 'smaller' 'smallest' */

const Title = ({
    isQuote = false,
    type = '',
    name = '',
    size = '',
    additionalClasses = [],
    refItem,
    style,
    children,
}) => {
    const classNames = [
        name ? `${name}__title` : null,
        'title',
        isQuote ? 'title--quote' : null,
        size ? `title--${size}` : null,
        ...additionalClasses,
    ];
    const classNamesJoined = prepareClassNames(classNames);

    switch (type) {
        case 'h1':
            return (
                <h1 className={classNamesJoined} ref={refItem} style={style}>
                    {children}
                </h1>
            );
        case 'h2':
            return (
                <h2 className={classNamesJoined} ref={refItem} style={style}>
                    {children}
                </h2>
            );
        case 'h3':
            return (
                <h3 className={classNamesJoined} ref={refItem} style={style}>
                    {children}
                </h3>
            );
        case 'h4':
            return (
                <h4 className={classNamesJoined} ref={refItem} style={style}>
                    {children}
                </h4>
            );
        default:
            return (
                <h2 className={classNamesJoined} ref={refItem} style={style}>
                    {children}
                </h2>
            );
    }
};

Title.propTypes = {
    isQuote: PropTypes.bool,
    type: PropTypes.string,
    name: PropTypes.string,
    size: PropTypes.string,
    additionalClasses: PropTypes.array,
    refItem: PropTypes.object,
    style: PropTypes.object,
};

export default Title;
